import { Link } from "react-router-dom";

export default function LegalLayout({ title, subtitle, children }) {
    return (
        <>
            <section className="bg-ink text-white">
                <div className="container-7m py-20 lg:py-28">
                    <Link to="/" className="text-xs font-mono uppercase tracking-[0.2em] text-white/40 hover:text-brand">← 7MED</Link>
                    <div className="mt-6 label-eyebrow !text-brand">Legale</div>
                    <h1 className="mt-3 font-heading font-black text-5xl lg:text-7xl tracking-tighter leading-none">{title}</h1>
                    {subtitle && <p className="mt-6 text-lg text-white/60 max-w-2xl">{subtitle}</p>}
                </div>
            </section>
            <section className="py-16 lg:py-24 bg-white">
                <div className="container-7m max-w-3xl">
                    <article className="legal-prose">{children}</article>
                </div>
                <style>{`
                    .legal-prose { font-size: 15px; line-height: 1.75; color: #1f2937; }
                    .legal-prose h2 { font-family: "Cabinet Grotesk", sans-serif; font-weight: 800; font-size: 22px; letter-spacing: -0.02em; margin-top: 40px; margin-bottom: 14px; color: #0a0a0a; }
                    .legal-prose h3 { font-family: "Cabinet Grotesk", sans-serif; font-weight: 700; font-size: 18px; margin-top: 28px; margin-bottom: 10px; color: #0a0a0a; }
                    .legal-prose p { margin-bottom: 14px; }
                    .legal-prose ul { margin: 14px 0 14px 24px; list-style-type: square; }
                    .legal-prose ul li { margin-bottom: 6px; }
                    .legal-prose a { color: #FF3B30; text-decoration: underline; }
                    .legal-prose a:hover { color: #D62828; }
                    .legal-prose strong { color: #0a0a0a; font-weight: 600; }
                `}</style>
            </section>
        </>
    );
}
